import gql from 'graphql-tag';

export const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($username: String!) {
    requestPasswordReset(username: $username) {
      ok
    }
  }
`;
